export enum Environment {
  test = 'test',
  local = 'local',
  development = 'development',
  integration = 'integration',
  production = 'production',
  'production.us-east-1' = 'production.us-east-1',
}
